<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="mainContentFullWith">
  <div class="headerContent" *ngIf="multiPartnerUser">
    <div class="traderContent">
      <h3 class="titles">{{translation.LoadVehicleDataByAddresses}}</h3>
      <div class="multiRow">
        <mat-form-field class="headerItem traderTypeInput">
          <mat-select (selectionChange)="onTypeSelectChange($event)" [(ngModel)]="selectedTraderType" placeholder="{{translation.TypeText}}">
            <mat-option *ngFor="let type of traderTypes" [value]="type.id">
              {{type.text}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="headerItem daysBackInput" id="noMarginRight">
          <mat-label>{{translation.AmountOfDaysSearch}}</mat-label>
          <input matInput type="number" min="0" [(ngModel)]="daysBackInput" (keydown.enter)="loadDataForGrid(false)">
        </mat-form-field>
      </div>
      <mat-form-field class="headerItem traderInput">
        <mat-label>{{translation.TraderText}}</mat-label>
        <mat-select [formControl]="traders" multiple (selectionChange)="onTraderSelectChange($event)" [(ngModel)]="selectedOption">
          <mat-option *ngFor="let trader of traderList" [value]="trader.id">{{trader.text}}</mat-option>
        </mat-select>
      </mat-form-field>
      <button class="customButton" type="button" mat-button color="primary" (click)="loadDataForGrid(false)">{{translation.LoadData}}</button>
    </div>
    <div class="middleContent">
      <div class="upperMiddleContent">
        <div class="upperLeftMiddleContent"></div>
        <div class="upperRightMiddleContent"></div>
      </div>
      <div class="centralContent">
        <h3 class="titles">{{translation.Or}}</h3>
      </div>
      <div class="lowerMiddleContent">
        <div class="lowerLeftMiddleContent"></div>
        <div class="lowerRightMiddleContent"></div>
      </div>
    </div>
    <div class="chassisAndReferenceContent">
      <h3 class="titles">{{translation.LoadVehicleDataByReferences}}</h3>
      <mat-form-field class="headerItem chassisInput">
        <mat-label>{{translation.ChassisNumber}}</mat-label>
        <input matInput type="text" [(ngModel)]="chassisNumber" (keydown.enter)="loadDataForGrid(true)">
        <button *ngIf="chassisNumber" matSuffix mat-icon-button aria-label="Clear" (click)="chassisNumber=''">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field class="headerItem referenceInput">
        <mat-label>{{translation.Reference}}</mat-label>
        <input matInput type="text" [(ngModel)]="referenceNumber" (keydown.enter)="loadDataForGrid(true)">
        <button *ngIf="referenceNumber" matSuffix mat-icon-button aria-label="Clear" (click)="referenceNumber=''">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <button class="customButton" type="button" mat-button color="primary" (click)="loadDataForGrid(true)">{{translation.LoadData}}</button>
    </div>
  </div>
  <div class="headerContent" *ngIf="!multiPartnerUser">
    <mat-form-field id="traderTypeInput" class="headerItem">
      <mat-select (selectionChange)="onTypeSelectChange($event)" [(ngModel)]="selectedTraderType" placeholder="{{translation.TypeText}}">
        <mat-option *ngFor="let type of traderTypes" [value]="type.id">
          {{type.text}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="headerItem">
      <mat-label>{{translation.TraderText}}</mat-label>
      <mat-select [formControl]="traders" multiple (selectionChange)="onTraderSelectChange($event)" [(ngModel)]="selectedOption">
        <mat-option *ngFor="let trader of traderList" [value]="trader.id">{{trader.text}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field id="daysBackInput" class="headerItem">
      <mat-label>{{translation.AmountOfDaysSearch}}</mat-label>
      <input matInput type="number" min="0" [(ngModel)]="daysBackInput" (keydown.enter)="loadDataForGrid(false)">
    </mat-form-field>
    <button mat-icon-button aria-label="refreshButton" (click)="loadDataForGrid(false)">
      <mat-icon class="material-icons" color="accent">refresh</mat-icon>
    </button>
  </div>
  <div id="addressContent" *ngIf="addressContentIsActive">
    <div class="addressItem">
      <h2>{{translation.Client}}</h2>
      <div>{{client.Name}}</div>
      <div>{{client.AddressLine1}}</div>
      <div>{{client.AddressLine2}}</div>
      <div>{{client.Zip}} / {{client.City}}</div>
      <br class="unselectable">
      <div class="line">
        <span class="material-icons unselectable iconMargin">mail_outline</span>
        <a *ngFor="let emailSplit of clientEmailSplit" href="mailto:{{emailSplit}}">{{emailSplit}}&nbsp;</a>
      </div>
      <div class="line">
        <span class="material-icons unselectable iconMargin">phone</span><a href="tel:+{{client.Phone}}">{{client.Phone}}</a>
      </div>
    </div>
    <div class="addressItem">
      <h2>{{translation.Sender}}</h2>
      <div>{{sender.Name}}</div>
      <div>{{sender.AddressLine1}}</div>
      <div>{{sender.AddressLine2}}</div>
      <div>{{sender.Zip}} / {{sender.City}}</div>
      <br class="unselectable">
      <div class="line">
        <span class="material-icons unselectable iconMargin">mail_outline</span>
        <div class="line">
          <a *ngFor="let emailSplit of senderEmailSplit" href="mailto:{{emailSplit}}">{{emailSplit}}&nbsp;</a>
        </div>
      </div>
      <div class="line">
        <span class="material-icons unselectable iconMargin">phone</span><a href="tel:+{{sender.Phone}}">{{sender.Phone}}</a>
      </div>
    </div>
    <div class="addressItem">
      <h2>{{translation.Recipient}}</h2>
      <div>{{recipient.Name}}</div>
      <div>{{recipient.AddressLine1}}</div>
      <div>{{recipient.AddressLine2}}</div>
      <div>{{recipient.Zip}} / {{recipient.City}}</div>
      <br class="unselectable">
      <div class="line">
        <span class="material-icons unselectable iconMargin">mail_outline</span>
        <a *ngFor="let emailSplit of recipientEmailSplit" href="mailto:{{emailSplit}}">{{emailSplit}}&nbsp;</a>
      </div>
      <div class="line">
        <span class="material-icons unselectable iconMargin">phone</span><a href="tel:+{{recipient.Phone}}">{{recipient.Phone}}</a>
      </div>
    </div>
  </div>
  <div class="statusGraphics">
    <div id="verticalStepperContainer" *ngIf="showVertical">
      <mat-stepper orientation="vertical" id="verticalStepper" [selectedIndex]="-1" contenteditable="false">
        <mat-step label="{{this.translation.IsChecked}}" completed="{{IsCheckedCompleted}}"></mat-step>
        <mat-step label="{{this.translation.Accepted}}" completed="{{AcceptedCompleted}}"></mat-step>
        <mat-step label="{{this.translation.Declined}}" completed="{{DeclinedCompleted}}"></mat-step>
        <mat-step label="{{this.translation.ScheduledForCollection}}" completed="{{ScheduledForCollectionCompleted}}"></mat-step>
        <mat-step label="{{this.translation.PickedUp}}" completed="{{PickedUpCompleted}}"></mat-step>
        <mat-step label="{{this.translation.ScheduledForDelivery}}" completed="{{ScheduledForDeliveryCompleted}}"></mat-step>
        <mat-step label="{{this.translation.InTransit}}" completed="{{InTransitCompleted}}"></mat-step>
        <mat-step label="{{this.translation.Delivered}}" completed="{{DeliveredCompleted}}"></mat-step>
      </mat-stepper>
    </div>
    <div id="horizontalStepperContainer" *ngIf="!showVertical">
      <mat-stepper orientation="horizontal" id="horizontalStepper" [selectedIndex]="-1" contenteditable="false">
        <mat-step label="{{this.translation.IsChecked}}" completed="{{IsCheckedCompleted}}"></mat-step>
        <mat-step label="{{this.translation.Accepted}}" completed="{{AcceptedCompleted}}"></mat-step>
        <mat-step label="{{this.translation.ScheduledForCollection}}" completed="{{ScheduledForCollectionCompleted}}"></mat-step>
        <mat-step label="{{this.translation.PickedUp}}" completed="{{PickedUpCompleted}}"></mat-step>
        <mat-step label="{{this.translation.InTransit}}" completed="{{InTransitCompleted}}"></mat-step>
        <mat-step label="{{this.translation.ScheduledForDelivery}}" completed="{{ScheduledForDeliveryCompleted}}"></mat-step>
        <mat-step label="{{this.translation.Delivered}}" completed="{{DeliveredCompleted}}"></mat-step>
      </mat-stepper>
    </div>
  </div>
  <ejs-grid #stateGrid
            (rowSelected)="rowSelect($event)"
            [locale]="locale"
            (toolbarClick)="toolbarClick($event)"
            [dataSource]="dataSource"
            [columns]="options">
  </ejs-grid>
  <div style="float: right; font-size: small">*{{this.translation.EstimatedDelivery}}</div>
</div>
<app-footer></app-footer>
